import './polyfill';
import '@src/error/error-handler';
import '@src/tracker/track-page-load';
import '@src/tracker/track-page-leave';
import '@src/utils/fix-global-blur-ios-bug.js';
import '@src/utils/handle-network-connection-change';
import renderApp from '@src/render-app';
import initialize from '@src/initialize';
import fetchMock from '@src/services/fetch-mock';

/**
 * 禁止浏览器自动帮助恢复滚动位置
 * @type {string}
 */
window.history.scrollRestoration = 'manual';

/**
 * 是否已经运行, 用于检查 hot reload
 */
let hasRan = false;

/**
 * 自执行入口
 */
(async () => {
  if (!hasRan) {
    /**
     * 拉取 mock 数据
     */
    await fetchMock();

    /**
     * 初始化
     */
    initialize();

    /**
     * 标识已经运行过
     */
    hasRan = true;
  }

  /**
   * 渲染App
   */
  renderApp();
})();

// /**
//  * 注册 service worker
//  */
// serviceWorker.register();

/**
 * 热更新
 */
if (module.hot) {
  module.hot.accept();
}
